// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
/**
 * NotesService.
 *
 * This service has data access functions for Notes related resources.
 */
export class AssetNotesService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    /**
     * Returns the notes for a security.
     *
     * @param id Asset ID
     * @param type Asset type
     */
    getNotes(id, type, limit) {
        const urlParams = { assetId: id, assetType: type };
        const queryParams = limit !== null ? { limit: limit } : undefined;
        const getNotesUrl = this.urlsService.getUrl(this.urlsService.NOTES.ASSET_NOTE_COLLECTION, urlParams, queryParams);
        return this.ajaxService.getDataObserveBody(getNotesUrl);
    }
    /**
     * Creates a new Note for a security.
     *
     * @param id Asset ID
     * @param type Asset type
     * @param noteText Note's text content.
     */
    createNote(id, noteText, type) {
        const postParams = { note_content: noteText, security_id: id, security_type: type };
        return this.ajaxService.postFormEncodedDataObserveBody(this.urlsService.NOTES.NOTE_COLLECTION, postParams);
    }
    /**
     * Deletes a Note with the given ID.
     *
     * @param id Note ID.
     */
    deleteNote(id) {
        const urlParams = { noteId: id };
        const deleteUrl = this.urlsService.getUrl(this.urlsService.NOTES.NOTE_ITEM, urlParams);
        return this.ajaxService.deleteDataObserveBody(deleteUrl);
    }
    /**
     * Updates a Note text content.
     *
     * @param id Note ID.
     * @param noteText Note text content.
     */
    updateNote(id, noteText) {
        const urlParams = { noteId: id };
        const putParams = { note_content: noteText };
        const putUrl = this.urlsService.getUrl(this.urlsService.NOTES.NOTE_ITEM, urlParams);
        return this.ajaxService.putDataObserveBody(putUrl, putParams);
    }
}
AssetNotesService.ɵfac = function AssetNotesService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AssetNotesService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AssetNotesService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AssetNotesService, factory: AssetNotesService.ɵfac, providedIn: 'root' });
